"use client";

import React, { createContext, useContext } from "react";
import { InteractiveCardItem } from "./types";
import { SizingOptions } from "modules/common/components/CardPreviewLoading";
import { SelectionState } from "modules/common/stores/useMultiSelectStore";

export interface SelectionContextValue {
  state: SelectionState;
  isAnySelected: boolean;
  onToggle: () => void;
  modeType: "none" | "store" | "controlled";
  /**
   * Under "select all" the store holds no ids, so it can't drop just this one —
   * onToggle clears the whole selection. Labels must say that instead of
   * promising a per-card "Deselect {name}" the store can't deliver.
   */
  clearsAll: boolean;
}

export interface CardGridItemContextValue {
  item: InteractiveCardItem;
  sizing: SizingOptions;
  selection: SelectionContextValue;
  onPrefetchTrigger: () => void;
}

const CardGridItemContext = createContext<CardGridItemContextValue | null>(
  null
);

export function CardGridItemProvider({
  value,
  children,
}: {
  value: CardGridItemContextValue;
  children: React.ReactNode;
}) {
  return (
    <CardGridItemContext.Provider value={value}>
      {children}
    </CardGridItemContext.Provider>
  );
}

export function useCardGridItemContext(): CardGridItemContextValue {
  const ctx = useContext(CardGridItemContext);
  if (!ctx) {
    throw new Error(
      "useCardGridItemContext must be used within CardGridItem.Root"
    );
  }
  return ctx;
}
